import { TabLink } from "components";

import styles from "./CompanyDetailsTabs.module.scss";

export type CompanyDetailsTab = "metrics" | "orders" | "drivers";

interface CompanyDetailsTabsProps {
  companyId: string;
  activeTab: CompanyDetailsTab;
  ordersCount?: number;
  driversCount?: number;
}

const CompanyDetailsTabs = ({
  companyId,
  activeTab,
  ordersCount,
  driversCount
}: CompanyDetailsTabsProps) => {
  return (
    <nav className={styles.tabs}>
      <TabLink
        pathName={`/companies/${companyId}/metrics`}
        label="Metrics"
        forceActive={activeTab === "metrics"}
      />
      <TabLink
        pathName={`/companies/${companyId}/orders`}
        label="Orders"
        counterValue={ordersCount}
        forceActive={activeTab === "orders"}
      />
      <TabLink
        pathName={`/companies/${companyId}/drivers`}
        label="Drivers"
        counterValue={driversCount}
        forceActive={activeTab === "drivers"}
      />
    </nav>
  );
};

export default CompanyDetailsTabs;
